import { ShaderMaterial } from '@babylonjs/core/Materials/shaderMaterial';
import { Effect } from '@babylonjs/core/Materials/effect';
import { type Scene as BScene } from '@babylonjs/core/scene';
import heatmapVertexShader from './glsl/heatmap/vertex.glsl';
import heatmapFragmentShader from './glsl/heatmap/fragment.glsl';

/**
 *
 * @param bscene -
 */
export function create(bscene: BScene): ShaderMaterial {
  // Add shaders to the store
  Effect.ShadersStore.heatmapVertexShader = heatmapVertexShader;
  Effect.ShadersStore.heatmapFragmentShader = heatmapFragmentShader;

  const shaderMaterial = new ShaderMaterial(
    'heatmap',
    bscene,
    {
      vertex: 'heatmap',
      fragment: 'heatmap',
    },
    {
      attributes: ['color', 'position'],
      defines: [],
      samplers: [],
      uniforms: ['heatMax', 'heatMin', 'worldViewProjection'],
    },
  );

  return shaderMaterial;
}

/**
 *
 * @param bscene -
 */
export function touch(bscene: BScene): ShaderMaterial {
  const materialId = 'heatMap';
  const found = bscene.materials.find(({ id }) => id === materialId);

  if (found) {
    return found as ShaderMaterial;
  }

  return create(bscene);
}
